import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import Slick from "react-slick";
import { Colors } from "./styles/Colors";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breakpoints from "./styles/Breakpoints";

const SLICK_OPTIONS = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  fade: true,
  draggable: false,
  appendDots: dots => (
    <div>
      <ul>
        {dots}
      </ul>
    </div>
  ),
  customPaging: i => (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9.5" stroke="#C4C4C4" />
      <path className="inner" d="M16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10L16 10Z" fill="#FFC000" />
    </svg>
  )
};

const Wrapper = styled.div`
  overflow: hidden;
  padding-bottom: 30px;

  position: relative;

  .gatsby-image-wrapper {
    height: 246px;
  }

  @media ${Breakpoints.tablet} {
    .gatsby-image-wrapper {
      height: 800px;
    }
  }

  .slick-dots {
    ul {
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: flex-start;
    }

    li {
      margin: 0 5px;

      @media ${Breakpoints.tablet} {
        margin: 0 10px 0 0;
      }

      svg {
        width: 20px;

        .inner {
          opacity: 0;
          transition: opacity .3s, fill .3s;
        }
      }

      &.slick-active {
        svg .inner {
          opacity: 1;
        }
      }

      &:hover {
        @media ${Breakpoints.tablet} {
          svg {
            .inner {
              fill: ${Colors.greyLight};
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;

const SealImage = styled.img`
  position: absolute;

  top: 10px;
  left: 10px;

  width: 65px;

  z-index: 10;

  @media ${Breakpoints.tablet} {
    width: 100px;
    top: 25px;
    left: 25px;
  }
`;

export default function ProductImageSlider({ slides, seal }) {
  const componentSlides =
    slides && slides.map((slide) => <Img fluid={slide.fluid} />);

  return (
    <Wrapper>
      {seal && <SealImage src={seal} />}
      <Slick {...SLICK_OPTIONS}>{componentSlides}</Slick>
    </Wrapper>
  );
}
